/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  floatingPanel: Item<'FloatingPanel'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  box: Item<'Box'>;
  typography: Item<'Typography'>;
} = {
  box: {
    children: ['typography'],
    itemId: 'box',
    parent: 'flexItem',
    props: {
      boxHeight: '1',
    },
    type: 'Box',
  },
  flexItem: {
    children: ['box'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'floatingPanel',
    props: {},
    type: 'FlexPanel',
  },
  floatingPanel: {
    children: ['flexPanel'],
    itemId: 'floatingPanel',
    parent: 'root',
    props: {
      border: {
        all: {
          style: 'solid',
          width: 1,
        },
      },
      borderRadius: 6,
      elevation: 10,
      left: -1,
      right: 20,
    },
    type: 'FloatingPanel',
  },
  root: {
    children: ['floatingPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'Floating Panel',
      },
      padding: { all: 20 },
    },
    type: 'Page',
  },
  typography: {
    children: [],
    itemId: 'typography',
    parent: 'box',
    props: {
      text: {
        type: 'text',
        value: 'Floating Panel',
      },
    },
    type: 'Typography',
  },
};

export const helpRenders: ComponentSample<'FloatingPanel'>[] = [
  {
    title: 'Floating Panel',
    page,
    exampleId: 'eg-01GK8RYGNDMME89SJ6GTP4CNBQ',
    clearParentChildren: true,
    height: 460,
    visibleProps: [
      'right',
      'left',
      'top',
      'bottom',
      'borderRadius',
      'elevation',
      'draggable',
      'dragMomentum',
    ],
    item: {
      itemId: 'floatingPanel',
      type: 'FloatingPanel',
      children: ['flexPanel'],
      parent: 'root',
      props: {
        right: 20,
        left: -1,
        borderRadius: 6,
        elevation: 10,
        border: {
          all: {
            width: 1,
            style: 'solid',
          },
        },
      },
    },
  },
];
